export default {
  upcoming: 0,
  living: 1,
  past: 2
};
